export default {
      id: "color_biome-usage",
      viewBox: "0 0 56 50",
      url: __webpack_public_path__ + "sprite.svg#color_biome",
      toString: function () {
        return this.url;
      }
    }